'use client';

import { useCallback, useContext } from 'react';
import DeferredStreamBoundary from '@/common/DeferredStreamBoundary';
import { DeferredRequestKey } from '~/constants/common/deferredRequests';
import DiscountContext from '~/context/vdp/DiscountContext';
import type { DiscountsResult } from '~/server-props/vdp/getDiscounts';

export default function DiscountsDeferred({
  promise
}: {
  promise: Promise<DiscountsResult | undefined>;
}) {
  const {
    discounts: { setData },
    triggerFetchDiscounts
  } = useContext(DiscountContext);

  const onResolve = useCallback(
    (data: DiscountsResult | undefined) => {
      if (data) {
        setData(data.response);
      } else {
        triggerFetchDiscounts();
      }
    },
    [setData, triggerFetchDiscounts]
  );

  return (
    <DeferredStreamBoundary
      deferredKey={DeferredRequestKey.Discounts}
      onResolve={onResolve}
      promise={promise}
    />
  );
}
